import React from 'react';

import { Button, Spin, Tooltip } from 'antd';

import { useFormikContext } from 'formik';
import { PersonalDocumentType } from 'v2/components/Pages/AddBankAccount/Stepper/form';
import type { INewAccount } from 'v2/interfaces/financial';

interface IProps {
  activeStep: number;
  hasVideo?: boolean;
  docType: string;
  onBack: () => void;
  onNext: () => void;
}

const NavButtons = ({ activeStep, hasVideo = true, docType, onBack, onNext }: IProps) => {
  const { dirty, isValid, values, isSubmitting, handleSubmit, setSubmitting, errors } = useFormikContext<INewAccount>();
  const { imgsIds, bank_id, operation_id } = values;

  const onSubmit = () => {
    setSubmitting(true);
    handleSubmit();
  };

  const tooltipMessage = Object.values(errors)[0] || '';
  const caixaEconomicaId = '104';

  return (
    <>
      {activeStep > 0 && <Button onClick={onBack}>Voltar</Button>}
      <Tooltip title={tooltipMessage as string} placement='top'>
        <div className='ml-auto'>
          {activeStep === 0 && (
            <Button
              type='primary'
              onClick={onNext}
              disabled={!dirty || !isValid || (bank_id === caixaEconomicaId && operation_id === 'not-selected')}
              className='ml-auto'
            >
              Próximo
            </Button>
          )}
          {activeStep === 1 && (
            <Button
              type='primary'
              onClick={onNext}
              disabled={
                (docType === PersonalDocumentType.CNH ? !imgsIds.imgDocCNH : !imgsIds.imgDocRG || !imgsIds.imgDocCPF) ||
                (hasVideo && !imgsIds.videoDoc) ||
                isSubmitting
              }
            >
              {isSubmitting ? 'Enviando...' : 'Próximo'} {isSubmitting && <Spin size='small' className='ml-2' />}
            </Button>
          )}
          {activeStep === 2 && (
            <Button
              type='primary'
              onClick={onNext}
              disabled={!imgsIds.imgBankReceipt || isSubmitting}
              className='ml-auto'
            >
              {isSubmitting ? 'Enviando...' : 'Próximo'} {isSubmitting && <Spin size='small' className='ml-2' />}
            </Button>
          )}
          {activeStep === 3 && (
            <Button type='primary' onClick={onSubmit} disabled={isSubmitting}>
              {isSubmitting ? 'Enviando... ' : 'Finalizar'} {isSubmitting && <Spin size='small' className='ml-2' />}
            </Button>
          )}
        </div>
      </Tooltip>
    </>
  );
};

export default NavButtons;
